import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {EmpionPaper} from '../../../../../../components/EmpionPaper/EmpionPaper';
import {EmpionTooltip} from '../../../../../../components/EmpionTooltip/EmpionTooltip';
import {LanguageContext} from '../../../../../../contexts/LanguageContext/LanguageContext';
import {greenColors, orangeColors} from '../../../../../../layouts/theme/designSystem';
import {CultureSatisfactionElement} from '../../types/CultureSatisfactionTypes';

interface CultureSatisfactionProps {
  cultureSatisfaction: CultureSatisfactionElement[];
}

export default function CultureSatisfaction({cultureSatisfaction}: CultureSatisfactionProps) {
  const {t} = useTranslation();
  const currentLanguage = useContext(LanguageContext);

  return (
    <Grid container mt={8}>
      <Typography variant='h2'>{t('companyCultureDashboard.satisfaction')}</Typography>
      <Grid container sx={{flexWrap: 'wrap'}} gap={2} mt={3}>
        <Grid container spacing={2}>
          {cultureSatisfaction.map((satisfaction) => {
            return (
              <Grid item xs={12} sm={4} key={satisfaction.key}>
                <EmpionTooltip title={satisfaction.title[currentLanguage]} placement='top' isEnabled>
                  <EmpionPaper
                    sx={{
                      borderRadius: '16px',
                      boxShadow: 'none',
                      height: '100%',
                      border: `1px solid ${orangeColors[3]}`,
                    }}
                  >
                    <Grid item container p={2}>
                      <Grid item container>
                        <Typography
                          variant='body1'
                          fontWeight={'bolder'}
                          color={greenColors[700]}
                          mr={1}
                        >
                          &empty;
                        </Typography>
                        <Typography variant='body1' fontWeight={'700'}>
                          {satisfaction.average}
                        </Typography>
                      </Grid>
                      <Typography variant='body1' color={greenColors[700]}>
                        {satisfaction.labels[currentLanguage]}
                      </Typography>
                    </Grid>
                  </EmpionPaper>
                </EmpionTooltip>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
}
